import { render } from "./Runtimes.vue?vue&type=template&id=74cb5fa8"
import script from "./Runtimes.vue?vue&type=script&lang=js"
export * from "./Runtimes.vue?vue&type=script&lang=js"

import "./Runtimes.vue?vue&type=style&index=0&id=74cb5fa8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__